import singleFileUpload from '../components/Upload/SingleFile/index'
import pdfViewer from '../components/OfficeViewer/PDF/index.js'
import excelViewer from '../components/OfficeViewer/Excel/index.js'
import wordViewer from '../components/OfficeViewer/Word/index.js'
import matchedOrder from '../components/MatchedOrder/index.js'
import matchedSupplier from '../components/MatchedSupplier/index.js'
import matchedContract from '../components/MatchedContract/index.js'
import matchedPurchase from '../components/MatchedPurchase/index.js'
export default {}.install = (Vue, options = {}) => {
  //全局公共方法
  Vue.mixin({
    methods: {
      getAuthHeaders() {
        return {
          Authorization: `Bearer ${sessionStorage.token ||localStorage.token|| ""}`
        };
      },
      singleFileUpload(row,accept,callback){
        return singleFileUpload(row,accept,callback)
      },
      pdfViewer(pdfUrl,filename,callback){
        return pdfViewer(pdfUrl,filename,callback)
      },
      excelViewer(excelUrl,filename,callback){
        return excelViewer(excelUrl,filename,callback)
        // const encodedUrl = encodeURIComponent(excelUrl);
        // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`)
      },
      wordViewer(wordUrl,filename,callback){
        return wordViewer(wordUrl,filename,callback)
        // const encodedUrl = encodeURIComponent(excelUrl);
        // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`)
      },
      matchedSupplier(supplierId,callback){
        return matchedSupplier(supplierId,callback)
      },
      matchedOrder(orderId,callback){
        return matchedOrder(orderId,callback)
      },
      matchedContract(contractId,callback){
        return matchedContract(contractId,callback)
      },
      matchedPurchase(purchaseId,callback){
        return matchedPurchase(purchaseId,callback)
      },
      //table的标题行格式
      headerStyle({ row,column, rowIndex, columnIndex }) {
        return 'background-color:#20b2aa;padding:7px 0;text-align:center;font-size:13px;border-color:#dddddd;color:#fff'
      },
    }
  });
}
